import PermissionAwareExportButton from "#src/batteries-included-components/Buttons/PermissionAwareExportButton/PermissionAwareExportButton";
import { useExportJobItems } from "#src/components/hooks/adapters/useJobs";
import {
  Accordion,
  Drawer,
  KeyValueList,
  NumberDataDisplay,
  Pill,
} from "@validereinc/common-components";
import { JobType } from "@validereinc/domain";
import classNames from "classnames/bind";
import React, { ReactElement } from "react";
import styles from "./JobDrawer.module.scss";

const { AccordionPanel } = Accordion;
const cx = classNames.bind(styles);

type JobDrawerProps = {
  setSelectedJob: React.Dispatch<React.SetStateAction<JobType | null>>;
  selectedJob: JobType | null;
  disableJobNavigation?: boolean;
};

export const JobDrawer = ({ setSelectedJob, selectedJob }: JobDrawerProps) => {
  const exportJobItemsPayload = {
    job_id: selectedJob?.id ?? "",
    filters: {},
  };

  const { mutate: handleExport, isLoading: isExporting } = useExportJobItems(
    exportJobItemsPayload
  );

  const onClose = () => {
    setSelectedJob(null);
  };

  const data: Array<{
    title: string;
    value: string | number | ReactElement;
  }> = [];

  if (selectedJob) {
    data.push({
      title: "Job Item Status",
      value: (
        <div className={cx("job-results-container")}>
          <Pill variant="success">
            {selectedJob.item_status_counts.success} Successful
          </Pill>
          <Pill variant="warning">
            {selectedJob.item_status_counts.skipped} Skipped
          </Pill>
          <Pill variant="error">
            {selectedJob.item_status_counts.failed} Failed
          </Pill>
        </div>
      ),
    });
    data.push({
      title: "Total Items",
      value: <NumberDataDisplay value={selectedJob.total_items} />,
    });
  }

  return (
    <Drawer
      size="md"
      isOpen={!!selectedJob}
      onClose={onClose}
      title={"Job Details"}
      actionRow={
        <div className={cx("action-row-container")}>
          <PermissionAwareExportButton
            key="export-devices"
            onClick={handleExport}
            isExporting={isExporting}
            label="Export Job Items"
            hasIcon={false}
            variant="primary"
          >
            Export Job Items
          </PermissionAwareExportButton>
        </div>
      }
    >
      <div className={cx("contentContainer")}>
        <Accordion defaultActiveKeys={["overview"]}>
          <AccordionPanel
            dataKey="overview"
            title="Overview"
          >
            {data.length > 0 ? (
              <KeyValueList
                data={data}
                color="neutral"
                variant="shaded"
              />
            ) : null}
          </AccordionPanel>
        </Accordion>
      </div>
    </Drawer>
  );
};
